import { render, staticRenderFns } from "./ClientDetails.vue?vue&type=template&id=fb4710f2&scoped=true&"
import script from "./ClientDetails.vue?vue&type=script&lang=js&"
export * from "./ClientDetails.vue?vue&type=script&lang=js&"
import style0 from "./_layout.css?vue&type=style&index=0&id=fb4710f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4710f2",
  null
  
)

export default component.exports